import axios from 'axios';
import domain from '@/scripts/domain';

// 创建专用于联考服务的axios实例
const jointExamAxios = axios.create({
  // 尝试从domain配置中获取联考服务域名，如果没有则使用单校考试域名
  baseURL: domain['examination-joint']
    ? domain['examination-joint']['exam-api-domain']
    : domain['examination-single']['exam-api-domain'],
  timeout: 30000,
});

// 获取认证Token
const getToken = () =>
  // 兼容客户端和网页端的token存储方式
  localStorage.getItem('examination_session_token')
         || localStorage.getItem('YUNQUE_EXAMINATION_session_id')
         || localStorage.getItem('YUNQUE_EXAMINATION_session_token')
;

// 不需要 token 的接口列表（登录、注册等）
const noTokenUrls = [
  '/v1/auth/login',
  '/v1/auth/register',
  '/v1/auth/sendPhoneCode',
  '/v1/auth/third_login',
  '/v1/teaching/getSchoolsForSchoolAdmin2',
  '/v2/answersheet/info',
  '/v2/answersheet'
];

// 请求拦截器，添加权限认证信息
jointExamAxios.interceptors.request.use(
  config => {
    // 检查是否是登录等不需要 token 的接口
    const isNoTokenUrl = noTokenUrls.some(url => config.url && config.url.includes(url));

    // 登录接口不需要 token，所以跳过
    if (!isNoTokenUrl) {
    // 添加认证Token
      const token = getToken();
      if (token) {
        config.headers.F_token = token;
      }

      // 添加user_id到header
      const userId = localStorage.getItem('examination_user_id')
                     || localStorage.getItem('YUNQUE_EXAMINATION_user_id');
      if (userId) {
        config.headers = config.headers || {};
        config.headers.user_id = userId;
      }
    }

    // 添加用户ID，某些客户端接口需要
    const userId = localStorage.getItem('YUNQUE_EXAMINATION_user_id');
    if (userId) {
      config.headers.F_user_id = userId;
    }

    console.log('联考API请求:', config.url, config.params || config.data);
    console.log('联考API基础URL:', config.baseURL);

    return config;
  },
  error => Promise.reject(error)
);

// 响应拦截器
jointExamAxios.interceptors.response.use(
  response => {
    console.log('联考API响应:', response.config.url, response.data);
    return response;
  },
  error => {
    console.error('联考API请求失败:', error.config ? error.config.url : '未知请求', error.message);

    // 处理 401 状态码，跳转到登录页面
    if (error.response && error.response.status === 401) {
      window.location.href = 'https://www.hhyunyue.com/exam/Login';
    }

    return Promise.reject(error);
  }
);

// 联考API服务
export default {
  // 获取学校参与的联考列表
  getJointExamListForSchool(params) {
    console.log('获取联考列表，参数:', params);

    // 使用客户端阅卷助手的API路径
    return jointExamAxios.get('/v1/desktop/all_list', { params })
      .then(response => {
        console.log('联考API响应成功:', response);
        return response;
      })
      .catch(error => {
        console.error('联考API请求失败:', error);
        return Promise.reject(error);
      });
  },

  // 获取联考详情
  getJointExamDetail(examId, subjectId) {
    // 使用客户端阅卷助手的API路径
    return jointExamAxios.get('/v1/desktop/exam', {
      params: { exam_id: examId, subject_id: subjectId }
    });
  },

  // 获取联考参与学校
  getJointExamSchools(examId) {
    // 使用客户端阅卷助手的API路径
    return jointExamAxios.get('/v1/desktop/school/list', {
      params: { exam_id: examId }
    });
  },

  // 获取指定学校参与的联考列表
  getSchoolJointExams(schoolId, page = 1, limit = 20) {
    return jointExamAxios.get('/v1/school/joint/list', {
      params: {
        school_id: schoolId,
        page,
        limit
      }
    });
  },

  // === 客户端阅卷助手API ===

  // 获取考试列表 (客户端阅卷助手)
  getDesktopExamList(params) {
    return jointExamAxios.get('/v1/desktop/list3', { params });
  },

  // 获取考试详情 (客户端阅卷助手)
  getDesktopExamDetail(examId, subjectId) {
    return jointExamAxios.get('/v1/desktop/exam', {
      params: { exam_id: examId, subject_id: subjectId }
    });
  },

  // 获取阅卷信息 (客户端阅卷助手)
  // getDesktopMarkingInfo(params) {
  //   return jointExamAxios.post('/v1/desktop/marking', params);
  // },

  // 上传试卷 (客户端阅卷助手)
  uploadAnswerSheet(params) {
    return jointExamAxios.post('/v1/desktop/upload', params);
  },

  // 删除扫描记录 (客户端阅卷助手)
  clearScanRecord(params) {
    return jointExamAxios.post('/v1/desktop/clear', params);
  },

  // 重新扫描 (客户端阅卷助手)
  reomrAnswerSheet(params) {
    return jointExamAxios.post('/v1/desktop/reomr', params);
  },

  // 完成阅卷 (客户端阅卷助手)
  completeMarking(params) {
    return jointExamAxios.post('/v1/desktop/complete', params);
  }
};
